var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"resource-box"},[_c('iframe',{staticClass:"iframe-box",attrs:{"src":"https://zsparkweb.jianshankeji.com/ptzy/","frameborder":"0"}}),_c('bottomNav',{attrs:{"choose":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }